import { find } from 'lodash';
import languageList from './lists/languages';

export default function getLanguageName(languageCode, withLocalName = true) {
  // Only first two letters are needed to detect language.
  languageCode = languageCode.substring(0, 2).toLowerCase();
  const lang = find(languageList, language => language.code === languageCode);

  if (lang) {
    return withLocalName ? `${lang.name} (${lang.local_name})` : lang.name;
  }

  return null;
}
